import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class ClassWebsiteRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    let slug = params.slug.toLowerCase()
    // Deleted or nonexistent slugs resolve to nothing rather than rejecting; the
    // template renders the 404 in place so the bad URL stays in the address bar.
    return get(this, "store").find("class-website-by-slug", slug)
  }
}
